module.exports = __webpack_public_path__ + "img/trivy-logo.36198969.svg";